import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_49: FaireProductEntity = {
  token: "catalog_prod_prod-49",
  type: "product",
  name: "Ceramic Bud Vase - Organic Shape",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 16.25,
  msrpDollars: 40.63,
  sku: "JA0049",
  caseSize: 12,
  material: "Metal",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 418,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
